export default __webpack_public_path__ + "static/media/loading-progress.b1818e83.svg";